module.exports = __webpack_public_path__ + "img/manor.8abc9bcc.png";